import { render, staticRenderFns } from "./VisitAndSalesStatistics.vue?vue&type=template&id=8a890c04&"
import script from "./VisitAndSalesStatistics.vue?vue&type=script&lang=js&"
export * from "./VisitAndSalesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports